import { ColumnMain } from "#/models/column-main";
import { Column } from "#/models/column";
import { Trans } from "@lingui/macro";
import React from "react";

const LegacyStockModel = (): ColumnMain => {

    const columns: Array<Column> = new Array();

    columns.push({ key: 'id', width: 80, filter: true, sorter: true, title: <Trans>ID</Trans> });
    columns.push({ key: 'item.itemNo', dataIndex: ['item', 'itemNo'], width: 150, filter: true, sorter: true, title: <Trans>MSC Part Number</Trans> });
    columns.push({ key: 'item.name', dataIndex: ['item', 'name'], width: 200, filter: true, sorter: true, title: <Trans>Item Name</Trans> });
    columns.push({ key: 'item.supplier.code', dataIndex: ['item', 'supplier', 'code'], width: 150, filter: true, sorter: true, title: <Trans>Supplier Code</Trans> });
    columns.push({ key: 'quantity', width: 180, filter: true, sorter: true, title: <Trans>MSC product relevant quantity</Trans> });
    columns.push({ key: 'validTo', width: 180, dateTimeFilter: true, sorter: true, title: <Trans>Valid To</Trans> });
    columns.push({ key: 'updatedDate', width: 180, dateTimeFilter: true, sorter: true, title: <Trans>Updated Date</Trans> });
    columns.push({ key: 'updatedBy', width: 200, filter: true, sorter: true, title: <Trans>Updated By</Trans> });
    columns.push({ key: 'createdDate', width: 180, dateTimeFilter: true, sorter: true, title: <Trans>Created Date</Trans>, direction: "desc" });
    columns.push({ key: 'createdBy', width: 200, filter: true, sorter: true, title: <Trans>Created By</Trans> });

    return {
        columns: columns,
        url: "/resource/legacy-stock"
    };

}
export default LegacyStockModel();

